export default __webpack_public_path__ + "static/PaPIR_Specifications-6fc19599c5c86748b52929f8df10bca4.webp";